"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEVELOPER_TYPE = void 0;
var DEVELOPER_TYPE;
(function (DEVELOPER_TYPE) {
    DEVELOPER_TYPE["FIELD_NAME"] = "is_developer";
    DEVELOPER_TYPE["True"] = "true";
    DEVELOPER_TYPE["False"] = "false";
})(DEVELOPER_TYPE = exports.DEVELOPER_TYPE || (exports.DEVELOPER_TYPE = {}));
